import React from "react";
import { NavLink } from 'react-router-dom';
import "./LandingPageFooter.css";

export default function LandingPageFooter() {
  return (
    <footer className="landing-footer" role="contentinfo" aria-labelledby="footer-heading">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-col footer-brand">
            <div className="footer-logo"><img style={{width:'50px' , height: '50px'}} src='/assets/nexorah-logo.png' alt="Nexorah Logo" /></div>
            <p className="footer-desc">
              AI-powered CPHQ exam preparation designed for healthcare quality professionals. Learn smarter, track your progress, and prepare with confidence through structured modules, exam-style practice, and AI support.
            </p>
            <p className="footer-trust">
              Designed around healthcare quality concepts and CPHQ-focused exam preparation.
            </p>

            <ul className="social-list" aria-label="Social links">
              <li>
                <a href="https://www.facebook.com/profile.php?id=61593246298098" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M22 12.07C22 6.48 17.52 2 12 2S2 6.48 2 12.07C2 17.08 5.66 21.25 10.44 22v-6.96H7.9v-2.97h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.45h-1.25c-1.23 0-1.61.77-1.61 1.56v1.87h2.74l-.44 2.97h-2.3V22C18.34 21.25 22 17.08 22 12.07z" fill="#ffffff" opacity="0.95"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/nexorah-ai/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M20.45 20.45h-3.56v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.08 1.4-2.08 2.86v5.49H8.93V9h3.42v1.56h.05c.48-.9 1.65-1.85 3.4-1.85 3.64 0 4.31 2.4 4.31 5.51v6.23zM5.34 7.43a2.06 2.06 0 11.001-4.123 2.06 2.06 0 01-.001 4.123zM7.12 20.45H3.56V9H7.12v11.45z" fill="#ffffff" opacity="0.95"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/nexorah.ai/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.9A4.1 4.1 0 1016.1 13 4.1 4.1 0 0012 8.9zm6.4-3.5a1 1 0 11-1 1 1 1 0 011-1z" fill="#ffffff" opacity="0.95"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UC1uKKye-G0uotAQlVZMswBg" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="social-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M23.5 6.2a3.02 3.02 0 00-2.12-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.38.56A3.02 3.02 0 00.5 6.2 31.6 31.6 0 000 12a31.6 31.6 0 00.5 5.8 3.02 3.02 0 002.12 2.14C4.5 20.5 12 20.5 12 20.5s7.5 0 9.38-.56a3.02 3.02 0 002.12-2.14A31.6 31.6 0 0024 12a31.6 31.6 0 00-.5-5.8zM9.75 15.5v-7l6.25 3.5-6.25 3.5z" fill="#ffffff" opacity="0.95"/>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col footer-links-col" aria-labelledby="useful-links-heading">
            <h4 id="useful-links-heading" className="footer-col-heading">Useful Links</h4>
            <ul className="useful-links">
              <li><NavLink to="/resources">Course Modules</NavLink></li>
              <li><NavLink to="/resources">AI Tutor</NavLink></li>
              <li><NavLink to="/question-bank">Mock Exam Simulator</NavLink></li>
              <li><NavLink to="/dashboard">Dashboard & Analytics</NavLink></li>
              <li><NavLink to={{ pathname: '/', hash: '#pricing-heading' }}>Pricing Plan</NavLink></li>
              <li><NavLink to={{ pathname: '/', hash: '#testimonials-heading' }}>Student Testimonials</NavLink></li>
              <li><NavLink to="/contact">Contact Support</NavLink></li>
            </ul>
          </div>

          <div className="footer-col footer-contact" aria-labelledby="contact-us-heading">
            <h4 id="contact-us-heading" className="footer-col-heading">Contact Us</h4>
            <ul className="contact-list">
              <li className="contact-list-item-top">
                <svg className="contact-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M12 21s6-4.8 6-10a6 6 0 10-12 0c0 5.2 6 10 6 10z" fill="#2979FF" opacity="0.9"/>
                  <circle cx="12" cy="11" r="2" fill="#0A2540" opacity="0.55"/>
                </svg>
                <span>Nexorah AI, 12645 Memorial Dr, Suite F1 #1221, Houston, TX 77024, USA</span>
              </li>
              <li>
                <svg className="contact-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M6.6 4.8h2.7l1.3 3.5-1.8 1.1a11 11 0 004.8 4.8l1.1-1.8 3.5 1.3v2.7A1.8 1.8 0 0116.4 18 12.2 12.2 0 015 6.6a1.8 1.8 0 011.6-1.8z" fill="#ffffff" opacity="0.9"/>
                </svg>
                <a href="tel:+17133990222">+1 713-399-0222</a>
              </li>
              <li>
                <svg className="contact-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M4 6.5h16a1.5 1.5 0 011.5 1.5v8a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 16V8A1.5 1.5 0 014 6.5z" fill="#ffffff" opacity="0.9"/>
                  <path d="M4.5 8l7.5 5.2L19.5 8" stroke="#0A2540" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" opacity="0.55"/>
                </svg>
                <a href="mailto:admin@nexorahai.com">admin@nexorahai.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom" role="navigation" aria-label="Footer bottom">
          <div className="bottom-left">© 2026 Nexorah. All rights reserved.</div>
          <div className="bottom-right">
            <NavLink to="/terms">Terms of Use</NavLink>
            <NavLink to="/privacy">Privacy Policy</NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
}